import InboxIcon from '@assets/icons/inbox.svg';
import { BadgeAbsolute } from '@/components/badge-absolute';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { useCallback, useEffect } from 'react';
import { useComponentFocus } from '@/hooks/use-component-focus';
import { useOrderInbounds } from '@/hooks/use-order-inbounds';
import { useSmartOrderUnreads } from '@/hooks/use-smart-order-unreads';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  badgeStyle?: StyleProp<ViewStyle>;
  iconColor?: string;
}

const POLL_INTERVAL_MS = 60000;

export const OrderInboundsIcon: React.FC<Props> = ({
  badgeStyle,
  iconColor,
}) => {
  const theme = useTheme();
  const { isOrderInboundsEnabled } = useOrderInbounds();
  const { hasUnread, refetch } = useSmartOrderUnreads();

  useEffect(() => {
    if (!isOrderInboundsEnabled) {
      return;
    }

    const interval = setInterval(() => {
      refetch();
    }, POLL_INTERVAL_MS);

    return () => {
      clearInterval(interval);
    };
  }, [isOrderInboundsEnabled, refetch]);

  const onFocus = useCallback(() => {
    if (isOrderInboundsEnabled) {
      refetch();
    }
  }, [isOrderInboundsEnabled, refetch]);

  useComponentFocus({ onFocus });

  return (
    <View style={styles.wrapper} testID="order-inbounds-icon">
      <InboxIcon
        height={24}
        stroke={iconColor ?? theme.colors.secondary}
        width={24}
      />

      {hasUnread ? (
        <BadgeAbsolute
          badgeStyle={[badgeStyle]}
          testID="order-inbounds-unread-badge"
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
  },
});
